import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ClientModelRestEndpointsClass;
function ClientModelRestEndpoints() {
  if (ClientModelRestEndpointsClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ClientModelRestEndpoints', VOID, VOID, VOID, [0, 1, 2]);
    ClientModelRestEndpointsClass = $;
  }
  return ClientModelRestEndpointsClass;
}
//region block: exports
export {
  ClientModelRestEndpoints as ClientModelRestEndpointsuzria74ft4w4,
};
//endregion

//# sourceMappingURL=ClientModelRestEndpoints.mjs.map
